import { SITE } from "../data/site";
import { useT } from "../i18n/LanguageContext";

export const Gallery = () => {
  const { t } = useT();
  const captions = t("gallery.captions"); // object

  const images = [
    { src: SITE.images.pizzaSiciliana, key: "sicilia", span: "row-span-2" },
    { src: SITE.images.pizzaDiavola,  key: "diavola" },
    { src: SITE.images.pizzaPesto,    key: "pesto" },
    { src: SITE.images.secondiPesce,  key: "pesce", span: "row-span-2" },
    { src: SITE.images.hero,          key: "hero" },
  ];

  return (
    <section id="galleria" data-testid="gallery-section" className="py-24 md:py-32 bg-[var(--cream)]">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center mb-14">
          <div className="gold-divider">
            <span className="line" />
            <span className="text-[11px] tracking-[0.3em] uppercase">{t("gallery.kicker")}</span>
            <span className="line" />
          </div>
          <h2 className="mt-6 font-display text-5xl md:text-6xl text-[var(--espresso)] tracking-tight-elegant">
            {t("gallery.titlePre")} <span className="italic font-serif-elegant text-[var(--gold-deep)]">{t("gallery.titleEm")}</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 auto-rows-[180px] md:auto-rows-[240px]">
          {images.map((img, i) => (
            <figure
              key={i}
              data-testid={`gallery-img-${i}`}
              className={`img-card group relative ${img.span || ""}`}
            >
              <img src={img.src} alt={captions?.[img.key] || ""} className="w-full h-full object-cover" />
              <figcaption className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-[rgba(42,31,24,0.85)] to-transparent text-[var(--ivory)] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <span className="font-serif-elegant italic text-base">{captions?.[img.key]}</span>
              </figcaption>
            </figure>
          ))}

          <div className="hidden lg:flex flex-col justify-center bg-[var(--espresso)] text-[var(--ivory)] p-8 row-span-2">
            <span className="text-[11px] tracking-[0.3em] uppercase text-[var(--gold-soft)]">Da Sofia</span>
            <p className="mt-4 font-display text-3xl leading-[1.1]">"{t("gallery.quote")}"</p>
            <span className="mt-6 h-px w-16 bg-[var(--gold)]" />
            <span className="mt-4 text-xs italic font-serif-elegant text-[var(--gold-soft)]">{t("gallery.sub")}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
